// extracted by mini-css-extract-plugin
export default {"RequestNewPasswordSuccessPage":"styles_RequestNewPasswordSuccessPage__Lyu9u","container":"styles_container__kfLg1"};